<template>
  <div style="min-width: var(--pc-page-min-width)">
    <div class="banner">
      <img src="/images/index/title.png" class="title" />
    </div>
    <div class="introduce">
      <img src="/images/index/introduceTitle.png" class="introduce-title" />
      <div class="highlight-container">
        <div v-for="(item, index) of highlightList" :key="item.line1" :class="`highlight highlight${index + 1}`">
          <div class="line1">{{ item.line1 }}</div>
          <div class="line2">{{ item.line2 }}</div>
        </div>
      </div>
      <div class="swiper">
        <img
          v-for="index of 8"
          :class="{
            'swiper-item': true,
            ll: index === swiperArr[0],
            l: index === swiperArr[1],
            c: index === swiperArr[2],
            r: index === swiperArr[3],
            rr: index === swiperArr[4]
          }"
          :src="`/images/index/swiper${index}.png`"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from '#imports'
import useGoMobile from '@/hooks/useGoMobile'

useGoMobile()
const highlightList = [
  { line1: '正版授权', line2: '设备三端互通' },
  { line1: '自由定制', line2: '可视化开发' },
  { line1: '多套专业底版', line2: '搭建个性化项目' },
  { line1: '持续更新', line2: '让您始终领先' }
]
const swiperArr = ref([1, 2, 3, 4, 5, 6, 7, 8])
let timer: number = null
onMounted(() => {
  timer = window.setInterval(() => {
    swiperArr.value.push(swiperArr.value.shift())
  }, 3000)
})
onUnmounted(() => {
  clearInterval(timer)
})
</script>

<style lang="scss" scoped>
.banner {
  background-image: url('/images/index/bannerBg.png');
  background-size: cover;
  background-position: bottom;
  height: 810px;
  padding-top: 315px;

  .title {
    display: block;
    height: 381px;
    margin: 0 auto;
  }
}

.introduce {
  height: 1080px;
  background-image: url('/images/index/introduceBg.png');
  background-size: cover;
  background-position: top;
  padding-top: 50px;

  .introduce-title {
    display: block;
    margin: 0 auto 8px;
    width: 462px;
    height: 99px;
  }

  .highlight-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1400px;
    height: 260px;
    margin: 0 auto 120px;

    .highlight {
      width: 316px;
      height: 208px;
      background-size: cover;
      transition: all 0.3s;
      cursor: pointer;
      color: #a0b7e5;
      text-align: right;
      font-size: 24px;
      font-weight: 500;
      line-height: 1.5;
      padding: 120px 18px 0;

      &:hover {
        width: 379px;
        height: 250px;
        color: #ffffff;
        font-size: 29px;
        padding: 153px 22px 0;
      }
    }

    .highlight1 {
      background-image: url('/images/index/highlight1.png');

      &:hover {
        background-image: url('/images/index/highlightHover1.png');
      }
    }

    .highlight2 {
      background-image: url('/images/index/highlight2.png');

      &:hover {
        background-image: url('/images/index/highlightHover2.png');
      }
    }

    .highlight3 {
      background-image: url('/images/index/highlight3.png');

      &:hover {
        background-image: url('/images/index/highlightHover3.png');
      }
    }

    .highlight4 {
      background-image: url('/images/index/highlight4.png');

      &:hover {
        background-image: url('/images/index/highlightHover4.png');
      }
    }
  }

  .swiper {
    mask: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, #07001c 20%, #181033 80%, rgba(0, 0, 0, 0) 100%);
    overflow: hidden;
    margin: 0 auto;
    position: relative;
    height: 360px;

    .swiper-item {
      border-radius: 16px;
      height: 360px;
      position: absolute;
      top: 0;
      transform: translateX(-50%);
      opacity: 0;
      visibility: hidden;
      transition: all 0.5s;
    }

    .l,
    .c,
    .r {
      opacity: 1;
      visibility: visible;
    }

    --index-swiper-width: 1200px;
    --index-swiper-gap: 40px;

    .ll {
      left: calc(50% - var(--index-swiper-width) - var(--index-swiper-gap) - var(--index-swiper-width));
    }

    .l {
      left: calc(50% - var(--index-swiper-width) - var(--index-swiper-gap));
    }

    .c {
      left: 50%;
    }

    .r {
      left: calc(50% + var(--index-swiper-width) + var(--index-swiper-gap));
    }

    .rr {
      left: calc(50% + var(--index-swiper-width) + var(--index-swiper-gap) + var(--index-swiper-width));
    }
  }
}
</style>
